import React from 'react'

import { connect } from "react-redux"

import { Card } from 'primereact/card'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'

import AuditLogTable from '../components/audit-log/audit-log-table'

import * as appActionCreators from "../actionCreators/app"
import * as auditLogActionCreators from "../actionCreators/auditLog"
import * as lobbyistActionCreators from "../actionCreators/lobbyist"

class AuditLog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedLobbyist: '',
      selectedTypeName: '',
      selectedAction: '',
      identifier: '',
      expandedTableRows: []
    }
  }

  componentDidMount() {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => this.props.getAuditLogTypeNames())
      .then(() => this.props.getLobbyistListItems())
      .then(() => this.props.getAuditLogEntries())
      .then(() => this.props.setLoading(false))
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.props.history.push('/error/401')
          this.props.setLoading(false)
        } else {
          this.props.handleError(error)
            .then(() => this.props.setLoading(false))
        }
      })
  }

  rowToggled = (e) => this.setState({ expandedTableRows: e.data })

  render() {
    let auditLogEntries = this.applyFilters(this.props.auditLog.auditLogEntries ? this.props.auditLog.auditLogEntries : [])
      .sort((a, b) => {
        return new Date(b.AuditDate) - new Date(a.AuditDate)
      })
    let typeNames = this.props.auditLog.typeNames.map(typeName => {
      return {
        label: typeName,
        value: typeName
      }
    })
    let actions = [
      { label: 'Insert', value: 'Insert' },
      { label: 'Update', value: 'Update' },
      { label: 'Delete', value: 'Delete' }
    ]
    let lobbyistListItems = this.props.lobbyist.lobbyistListItems.sort((a, b) => {
      return ('' + a.TradingName).localeCompare(b.TradingName)
    }).map(lobbyist => {
        return {
          label: lobbyist.TradingName + ' - ' + lobbyist.Abn,
          value: lobbyist.LobbyistId
        }
      })
    return (
      <div className="audit-log">
        <Card title={"View Audit Logs"}>
          <div className="p-grid">
            <div className="p-col-12 field-label-container">
              <label>Lobbyist</label>
            </div>
            <div className="p-col-12 field-element-container">
              <Dropdown value={this.state.selectedLobbyist} options={lobbyistListItems} style={{ width: '100%' }}
                onChange={e => { this.setState({ selectedLobbyist: e.value }) }} showClear={true}
              />
            </div>
            <div className="p-col-12 field-label-container">
              <label>Audit Type Name</label>
            </div>
            <div className="p-col-12 field-element-container">
              <Dropdown value={this.state.selectedTypeName} options={typeNames} style={{ width: '100%' }}
                onChange={e => { this.setState({ selectedTypeName: e.value }) }} showClear={true}
              />
            </div>
            <div className="p-col-12 field-label-container">
              <label>Audit Action</label>
            </div>
            <div className="p-col-12 field-element-container">
              <Dropdown value={this.state.selectedAction} options={actions} style={{ width: '100%' }}
                onChange={e => { this.setState({ selectedAction: e.value }) }} showClear={true}
              />
            </div>
            <div className="p-col-12 field-label-container">
              <label>Identifier</label>
            </div>
            <div className="p-col-12 field-element-container">
              <InputText value={this.state.identifier}
                onChange={e => { this.setState({ identifier: e.target.value }) }}
              />
            </div>
            <div className="p-col-12">
              <AuditLogTable auditLogEntries={auditLogEntries} expandedRows={this.state.expandedTableRows} rowToggled={this.rowToggled} />
            </div>
          </div>
        </Card >
      </div>
    )
  }

  applyFilters = auditLogEntries => {
    if (this.state.selectedLobbyist) {
      auditLogEntries = auditLogEntries.filter(entry => entry.LobbyistId === this.state.selectedLobbyist)
    }
    if (this.state.selectedAction) {
      auditLogEntries = auditLogEntries.filter(entry => entry.Action === this.state.selectedAction)
    }
    if (this.state.selectedTypeName) {
      auditLogEntries = auditLogEntries.filter(entry => entry.TypeName === this.state.selectedTypeName)
    }
    if (this.state.identifier) {
      auditLogEntries = auditLogEntries.filter(entry => entry.PrimaryId === this.state.identifier)
    }

    return auditLogEntries
  }
}

const mapStateToProps = (state) => {
  let { auditLog, lobbyist } = state
  return { auditLog, lobbyist }
}

// this is how to combine actions available
const actionCreators = {
  ...lobbyistActionCreators,
  ...appActionCreators,
  ...auditLogActionCreators
}

export default connect(mapStateToProps, actionCreators)(AuditLog)


// WEBPACK FOOTER //
// ./src/container/AuditLog.js